const CONSTANTS = {
  ADMIN_KEY: 2,
};

export default CONSTANTS;
